import React, { useEffect, useState } from "react";
import {
  Content,
  Row,
  Col,
  Box,
  Button,
  Inputs,
  SimpleTable,
  Pagination,
} from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../utils/Loader";

const { Select2, Date, DateTime, Text } = Inputs;

function ProfesionalesList({ history, match }) {
  const dispatch = useDispatch();

  const modelProfesionales = useSelector((state) => state.profesionalesByLocal);

  const [profesionales, setProfesionales] = useState(null);
  const [totalResultsProf, setTotalResultsProf] = useState(0);
  const [activePageProf, setActivePageProf] = useState(0);
  const [pageSizeProf, setPageSizeProf] = useState(5);

  useEffect(() => {
    const data = modelProfesionales?.data?.data;
    const error = modelProfesionales?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckProfesionalesByLocal.actions.clear());
    }
    if (data) {
      setProfesionales(data.data.items);
      setTotalResultsProf(data.data.total);

      dispatch(controller.duckProfesionalesByLocal.actions.clear());
    }
  }, [modelProfesionales]);

  useEffect(() => {
    dispatch(
      controller.profesionalesByLocalThunk(
        match.params.organizacion,
        1,
        pageSizeProf
      )
    );
  }, []);

  function handlePage(page) {
    setActivePageProf(page);
    setProfesionales([]);
    dispatch(
      controller.profesionalesByLocalThunk(
        match.params.organizacion,
        page + 1,
        pageSizeProf
      )
    );
  }

  return (
    <Content
      title="Profesionales"
      subTitle="Profesionales"
      browserTitle="Profesionales"
      show={false}
    >
      <Row>
        <Col md="8">
          <Box title="Profesionales">
            <Button
              type="primary"
              text="Agregar"
              pullRight={true}
              onClick={() =>
                history.push(`/nuevoProfesional/${match.params.organizacion}`)
              }
            />
            <div>
              <span>Total: {totalResultsProf}</span>
            </div>
            <Loader isLoading={modelProfesionales.loading}>
              {profesionales && profesionales.length > 0 ? (
                <SimpleTable
                  hover={true}
                  data={profesionales.map((row, index) => {
                    return {
                      nombre: row.nombre,
                      estado: row.estado,
                      editar: (
                        <Button
                          type="primary"
                          text="Editar"
                          onClick={() =>
                            history.push(`/editProfesional/${row._id}`)
                          }
                        />
                      ),
                    };
                  })}
                  columns={[
                    { title: "Nombre", data: "nombre" },
                    { title: "Estado", data: "estado" },
                    { title: "Editar", data: "editar" },
                  ]}
                />
              ) : (
                <h4>No se han encontrado profesionales</h4>
              )}
            </Loader>
            <Pagination
              activePage={activePageProf}
              pageSize={pageSizeProf}
              totalElements={totalResultsProf}
              onChange={handlePage}
              labels={{
                first: "Primera",
                last: "Última",
                previous: "Anterior",
                next: "Siguiente",
              }}
            />
            <div>
              <span>Total: {totalResultsProf}</span>
            </div>
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default ProfesionalesList;
